export const smallImageWidth = '130px';
export const mediumImageWidth = '160px';
export const bigImageWidth = '180px';



// WEBPACK FOOTER //
// ./src/common/consts/person-image.js